/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayoutSidebarRightInactive = createReactComponent("outline", "layout-sidebar-right-inactive", "IconLayoutSidebarRightInactive", [["path", { "d": "M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z", "key": "svg-0" }], ["path", { "d": "M15 4v1", "key": "svg-1" }], ["path", { "d": "M15 9v1", "key": "svg-2" }], ["path", { "d": "M15 14v1", "key": "svg-3" }], ["path", { "d": "M15 19v1", "key": "svg-4" }]]);

export { IconLayoutSidebarRightInactive as default };
//# sourceMappingURL=IconLayoutSidebarRightInactive.mjs.map
